var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board"},[_c('div',{staticClass:"board-grid"},_vm._l((_vm.cells),function(ref){
var row = ref.row;
var col = ref.col;
var isStone = ref.isStone;
var isMove = ref.isMove;
var color = ref.color;
return _c('div',{key:(row + "-" + col),class:("board-cell " + ((row + col) % 2 === 1 ? 'board-cell--alternate' : ''))},[(isStone)?_c('Stone',{staticClass:"board-stone",attrs:{"color":color}}):_vm._e(),(isMove)?_c('Move',{staticClass:"board-move",attrs:{"color":color,"title":_vm.position(row, col)},on:{"clicked":function($event){_vm.$emit('moved', row, col)}}}):_vm._e()],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }